import React, { PureComponent } from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import _compact from 'lodash/compact';
import _get from 'lodash/get';
import _pick from 'lodash/pick';
import SVG from 'react-inlinesvg';
import infoIcon from '@lifesize/ux-assets/vectors/svgIcons/information-outline.svg';
import handIcon from '@lifesize/ux-assets/vectors/svgIcons/hand.svg';
import Tooltip from 'components/Tooltip/Tooltip';
import { LOWER_HAND_BUTTON, RAISE_HAND_BUTTON } from 'constants/lsqaConstants';
import { tooltipNotificationTypes } from 'constants/Notification';
import classes from 'components/InCall/CallFooter.module.scss';

export class RaiseHandButton extends PureComponent {
  getTooltipLabel = (isRaised) => {
    const hasNotificationError = (_get(this.props, 'notification.messageType') === tooltipNotificationTypes.error);
    
    if (!!this.props.notification) {
      if (hasNotificationError) return (
        <div className={`${classes.tooltipLabelWithIcon} ${classes.error}`}>
          <SVG src={infoIcon} data-testid="infoIcon" />
          <div className={classes.message}>
            <FormattedMessage {..._pick(this.props.notification, ['id', 'defaultMessage', 'values'])} />
          </div>
        </div>
      );
      return (
        <FormattedMessage {..._pick(this.props.notification, ['id', 'defaultMessage', 'values'])} />
      );
    }
    return isRaised
      ? (
        <FormattedMessage
          id="components.incall.controls.raiseHand.tooltip.lowerHand"
          defaultMessage="Lower hand"
        />
      )
      : (
        <FormattedMessage
          id="components.incall.controls.raiseHand.tooltip.raiseHand"
          defaultMessage="Raise hand"
        />
      );
  }

  render() {
    const { disabled, handIsProcessing, handIsRaised, isConnected, notification, onRaiseHand } = this.props;
    const isRaised = handIsProcessing
      ? !handIsRaised
      : handIsRaised;

    if (!isConnected) return null;
    return (
      <button
        className={_compact([classes.btn, classes.btnRaiseHand, isRaised && classes.active]).join(' ')}
        disabled={disabled || handIsProcessing}
        onClick={() => onRaiseHand(isRaised)}
        {...(isRaised ? LOWER_HAND_BUTTON : RAISE_HAND_BUTTON)}
      >
        <SVG src={handIcon} />
        <Tooltip
          label={this.getTooltipLabel(isRaised)}
          location="top"
          visible={!!notification}
          useAltStyle={!!notification}
          style={{ bottom: '100%', marginBottom: 15 }}
        />
      </button>
    );
  }
}

RaiseHandButton.propTypes = {
  disabled: PT.bool,
  handIsProcessing: PT.bool,
  handIsRaised: PT.bool,
  isConnected: PT.bool,
  notification: PT.object,
  onRaiseHand: PT.func.isRequired,
  intl: PT.object
};

export default injectIntl(RaiseHandButton);
